import { ProspectSchema } from '@lsq-frontend/remote-services/ar-app';

export const mockProspectSchema: ProspectSchema = {
    id: 'id',
    name: undefined,
    stageSchemas: [
        {
            id: 'stage-id',
            name: 'undefined',
            label: 'stage 1',
            category: undefined,
            description: undefined,
            reviewTitle: 'stage 1',
            isReviewable: true,
            fieldSchemas: [
                {
                    id: 'input-1',
                    name: 'input-1',
                    label: 'input 1',
                    tooltip: '',
                    fieldType: 'StringField',
                    isRequired: true
                },
                {
                    id: 'input-2',
                    name: 'input-2',
                    label: 'input 2',
                    tooltip: '',
                    fieldType: 'DocumentField'
                }
            ]
        },
        {
            id: 'stage-id-b',
            name: 'undefined',
            label: 'stage 2',
            category: undefined,
            description: undefined,
            isBackward: true,
            fieldSchemas: [
                {
                    id: 'input-3',
                    name: 'input-3',
                    label: 'input 3',
                    tooltip: '',
                    fieldType: 'StringField'
                },
                {
                    id: 'input-4',
                    name: 'input-4',
                    label: 'input 4',
                    tooltip: '',
                    fieldType: 'DocumentField'
                }
            ]
        },
        {
            id: 'stage-review',
            name: undefined,
            label: 'label',
            category: undefined,
            description: 'description',
            isBackward: true,
            fieldSchemas: []
        }
    ]
};
